const services = {
  PROGRAMS: 'programs',
  USERS: 'users',
  TRANSACTIONS: 'transactions',
  STORAGE: 'storage',
  CUSTOMERS: 'customers',
  REPORTS: 'reporting',
  PRODUCTS: 'products',
};

const programId = process.env.REACT_APP_CONNECT_PROGRAM_ID;
const keycloakUrl = process.env.REACT_APP_CONNECT_KEYCLOAK_URL;

export const endpoints = {
  KEYCLOAK_URI: `${keycloakUrl}/realms/${programId}`,
  // PROGRAMS
  FETCH_CONFIG: `${services.PROGRAMS}/${programId}/config`,
  FETCH_VERSION: `${services.PROGRAMS}/${programId}/version`,
  // STORAGE
  UPLOAD_PHOTO: `${services.STORAGE}/${programId}/upload`,
  // TRANSACTION
  VERIFY_TRANSACTION: `${services.TRANSACTIONS}/${programId}/purchase/verify`,
  VERIFY_PATIENT_ELIGIBILITY: `${services.TRANSACTIONS}/${programId}/purchase`,
  VERIFY_REDEEM: `${services.TRANSACTIONS}/${programId}/purchase`,
  PURCHASE: `${services.TRANSACTIONS}/${programId}/purchase`,
  REDEEM: `${services.TRANSACTIONS}/${programId}/purchase`,
  // REGISTRATION
  USER_REGISTRATION: `${services.USERS}/${programId}/registration`,
  PATIENT_PRE_REGISTRATION: `${services.USERS}/${programId}/preregistration`,
  EMAIL_VERIFICATION: `${services.USERS}/${programId}/registration/verify`,
  RESEND_EMAIL_VERIFICATION: `${services.USERS}/${programId}/registration/verify/resend`,
  GET_USER: `${services.USERS}/${programId}/profile`,
  UPDATE_PASSWORD: `${services.USERS}/${programId}/profile/update-password`,
  LOGOUT: `${services.USERS}/${programId}/auth/logout`,
  // REPORTING
  TRANSACTION_HISTORY: `${services.REPORTS}/${programId}/core/transactions/list`,
  // PRODUCTS
  GET_PRODUCTS: `${services.PRODUCTS}/${programId}/catalog`,
};

export const screening = [
  {
    name: 'q1',
    question:
      '1. Do you sometimes forgot to take your high blood pressure pills?',
  },
  {
    name: 'q2',
    question:
      '2. Over the past 2 weeks, were there any days when you did not take your high blood pressure medicine?',
  },
  {
    name: 'q3',
    question:
      '3. Have you ever cut back or stopped taking your medication without telling your doctor because you felt worse when you took it?',
  },
  {
    name: 'q4',
    question:
      '4. When you travel or leave home, do you sometimes forget to bring along your medications?',
  },
  {
    name: 'q5',
    question: '5. Did you take your high blood pressure medicine yesterday?',
  },
  {
    name: 'q6',
    question:
      '6. When you feel like your blood pressure is under control, do you sometimes stop taking your medicine?',
  },
  {
    name: 'q7',
    question:
      '7. Taking medication everyday is a real inconvenience for some people. Do you feel hassled about sticking to your blood pressure treatment plan?',
  },
  {
    name: 'q8',
    question:
      '8. How often do you have difficulty remembering to take all your blood pressure medication?',
  },
];

export const settingsConfig = [
  {
    programId: 'sanofi-my-develop',
    name: 'old_password',
    label: 'Old Password',
    forUserType: 'patient',
    type: 'secure_input',
    title: null,
    hint: '',
    placeholder: 'Old Password',
    prefix: null,
    isRequired: true,
    isDefault: true,
    regexValidations: [
      {
        regex: '^.{8,}$',
        errorMessage: 'Old password needs to be at least 8 characters long.',
      },
      {
        regex: '^.*[A-Z]',
        errorMessage:
          'Old password needs to include at least one upper case English Letter.',
      },
      {
        regex: '^.*[a-z]',
        errorMessage:
          'Old password needs to include at least one lower case English Letter.',
      },
      {
        regex: '^.*[0-9]',
        errorMessage: 'Old password needs to include at least one number.',
      },
      {
        regex: '^.*[@#$%^&+=!*()?]',
        errorMessage:
          'Old password needs to include at least one special character.',
      },
    ],
    errorMessage: 'Old Password is Required',
    model: 'User',
    modelPath: null,
    fieldTypeOptions: {
      characterLimit: 50,
    },
    order: 1,
    isUnique: false,
    uniqueErrorMessage: '',
    isVisible: true,
    isEditable: false,
    metadata: null,
    createdAt: '2020-10-22T03:40:08.000Z',
    updatedAt: '2020-10-22T03:40:08.000Z',
    deletedAt: null,
  },
  {
    programId: 'sanofi-my-develop',
    name: 'password',
    label: 'New Password',
    forUserType: 'patient',
    type: 'secure_input',
    title: null,
    hint: '',
    placeholder: 'New Password',
    prefix: null,
    isRequired: true,
    isDefault: true,
    regexValidations: [
      {
        regex: '^.{8,}$',
        errorMessage: 'New password needs to be at least 8 characters long.',
      },
      {
        regex: '^.*[A-Z]',
        errorMessage:
          'New password needs to include at least one upper case English Letter.',
      },
      {
        regex: '^.*[a-z]',
        errorMessage:
          'New password needs to include at least one lower case English Letter.',
      },
      {
        regex: '^.*[0-9]',
        errorMessage: 'New password needs to include at least one number.',
      },
      {
        regex: '^.*[@#$%^&+=!*()?]',
        errorMessage:
          'New password needs to include at least one special character.',
      },
    ],
    errorMessage: 'New Password is Required',
    model: 'User',
    modelPath: null,
    fieldTypeOptions: {
      characterLimit: 50,
    },
    order: 2,
    isUnique: false,
    uniqueErrorMessage: '',
    isVisible: true,
    isEditable: false,
    metadata: null,
    createdAt: '2020-10-22T03:40:08.000Z',
    updatedAt: '2020-10-22T03:40:08.000Z',
    deletedAt: null,
  },
  {
    programId: 'sanofi-my-develop',
    name: 'confirm_password',
    label: 'Confirm Password',
    forUserType: 'patient',
    type: 'secure_input',
    title: null,
    hint: '',
    placeholder: 'Confirm Password',
    prefix: null,
    isRequired: true,
    isDefault: true,
    regexValidations: [
      {
        regex: '^.{8,}$',
        errorMessage:
          'Confirm password needs to be at least 8 characters long.',
      },
      {
        regex: '^.*[A-Z]',
        errorMessage:
          'Confirm password needs to include at least one upper case English Letter.',
      },
      {
        regex: '^.*[a-z]',
        errorMessage:
          'Confirm password needs to include at least one lower case English Letter.',
      },
      {
        regex: '^.*[0-9]',
        errorMessage: 'Confirm password needs to include at least one number.',
      },
      {
        regex: '^.*[@#$%^&+=!*()?]',
        errorMessage:
          'Confirm password needs to include at least one special character.',
      },
    ],
    errorMessage: 'Confirm Password is Required',
    model: 'User',
    modelPath: null,
    fieldTypeOptions: {
      characterLimit: 50,
    },
    order: 3,
    isUnique: false,
    uniqueErrorMessage: '',
    isVisible: true,
    isEditable: false,
    metadata: null,
    createdAt: '2020-10-22T03:40:08.000Z',
    updatedAt: '2020-10-22T03:40:08.000Z',
    deletedAt: null,
  },
];
